import React from 'react';
import { AwardIcon, CheckCircleIcon, UsersIcon, ShieldIcon } from 'lucide-react';
export const USPSection = () => {
  const usps = [{
    icon: <AwardIcon size={56} className="text-[#D6281F]" data-id="element-565" />,
    title: 'Vakmanschap',
    points: ['Jarenlange ervaring in premium car styling', 'Oog voor detail bij elke klus', 'Gecertificeerde specialisten']
  }, {
    icon: <CheckCircleIcon size={56} className="text-[#D6281F]" data-id="element-566" />,
    title: 'Hoogwaardige Materialen',
    points: ['Uitsluitend premium merken en materialen', 'Langdurige bescherming en afwerking', 'Duurzame resultaten']
  }, {
    icon: <UsersIcon size={56} className="text-[#D6281F]" data-id="element-567" />,
    title: '100% Maatwerk',
    points: ['Persoonlijke service en advies', 'Op maat gemaakte oplossingen', 'Volledig afgestemd op jouw wensen']
  }, {
    icon: <ShieldIcon size={56} className="text-[#D6281F]" data-id="element-568" />,
    title: 'Garantie',
    points: ['Volledige tevredenheidsgarantie', 'Professionele nazorg', 'Transparante werkwijze']
  }];
  return <section className="py-24 bg-gradient-to-b from-[#0a0a0a] to-[#121212]" data-id="element-569">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-570">
        <div className="text-center mb-16" data-id="element-571">
          <h2 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-572">
            <span className="text-[#D6281F]" data-id="element-573">Waarom</span>{' '}
            <span className="text-white" data-id="element-574">BKCustoms?</span>
          </h2>
          <p className="text-[#CCCCCC] max-w-2xl mx-auto" data-id="element-575">
            Wij onderscheiden ons door kwaliteit, precisie en passie.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10" data-id="element-576">
          {usps.map((usp, index) => <div key={index} className="bg-[#121212] rounded-lg border border-[#222222] hover:border-[#D6281F] transition-all duration-300 p-8 hover:shadow-[0_0_30px_rgba(214,40,31,0.2)] group" data-id="element-577">
              <div className="flex justify-center mb-6 transition-transform duration-300 group-hover:scale-110" data-id="element-578">
                {usp.icon}
              </div>
              <h3 className="text-2xl font-bold text-white mb-5 text-center" data-id="element-579">
                {usp.title}
              </h3>
              <ul className="text-[#CCCCCC] space-y-3" data-id="element-580">
                {usp.points.map((point, i) => <li key={i} className="flex items-start" data-id="element-581">
                    <span className="text-[#D6281F] mr-2 text-lg" data-id="element-582">•</span>
                    <span className="text-sm" data-id="element-583">{point}</span>
                  </li>)}
              </ul>
            </div>)}
        </div>
      </div>
    </section>;
};